import { resolveFilterLabelsToIds } from '../../versa/filter.js';

/**
 * Resolve o UUID da empresa (tenant) para ações que não exibem o campo «Empresa» no modal.
 * Ordem: filtro da grade → linha(s) selecionada(s) → página atual (apenas se um único tenant).
 */
export async function resolveTenantCompanyId(crud_)
{
	if (!crud_)
		return null;

	let f = crud_.filter;
	if (f && Object.keys(f).some(k => /^field-\d+$/.test(k)))
		f = await resolveFilterLabelsToIds(f, crud_.fieldspecs);

	for (let i = 0; i < 12; i++)
	{
		if (f[`field-${i}`] === 'company_id' && f[`value-${i}`])
			return String(f[`value-${i}`]).trim();
	}

	const sel = crud_.getSelection?.();
	if (sel && sel.length)
	{
		const parsed = JSON.parse(sel[0]);
		if (parsed[0])
			return String(parsed[0]).trim();
	}

	try
	{
		const rows = await crud_.queryData(await crud_.queryPage());
		if (Array.isArray(rows) && rows.length)
		{
			const ids = [...new Set(rows.map(r => r.company_id).filter(Boolean))];
			if (ids.length === 1)
				return String(ids[0]).trim();
		}
	}
	catch (e)
	{
		console.warn(e);
	}

	return null;
}
